import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { SetUserAction, DeactivateUserAction } from '../redux/user.actions';
import { Router } from '@angular/router';
import { SetCategorieAction, UnsetCategorieAction } from '../redux/categories.actions';
import { SetCategorieDoctorsAction, UnsetCategorieDoctorsAction } from '../redux/categories-doctors.actions';
import { ActivateLoadingAction, DeactivateLoadingAction } from '../redux/ui.actions';
import { GetChatHistory } from '../redux/chat-history.actions';
import moment from 'moment';
// import { environment } from 'src/environments/environment.prod';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly DEFAULT_ENC_KEY = "OnnptHpzXXyREqAbmRYx0RCgp1vMRoHA";
  private publicKey = "";
  private secureIV = "";
  private privateKey = "";
  public token = "";

  // URL Produccion
  // public newUrl = "https://apignp.mindhelp.mx/api/v1/";
  // URL Develop
  public newUrl = environment.apimh_url//"https://apignp.mindhelp.dev/api/v1/";
  // URL Local
  //public newUrl = 'http://192.168.100.35:1337/api/v1/';

  public conektaApiKey = "";
  public user = null;
  private loadingSpecialities = false;

  public PAYMETHODS = {cupon:1,tarjeta:2,tarjetacupon:3,creditos:4};

  constructor(private http: HttpClient, private store: Store<AppState>, private route: Router) { }

  conektaKey() {
    let url = `${this.newUrl}system/payments/keys`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token,
    });

    this.http.get(url, { headers }).subscribe({
      next: (d: any) => {
        const decUser = this.parseEncryptedResponse(d, "private");
        this.conektaApiKey = decUser.data.items[0].publicApiKey;
        console.log('APIKEY',this.conektaApiKey)
      },
      error: (err) => this.handleRequestError(err, {
        showModal: false,
        fallback: 'No pudimos cargar la configuración de pagos.'
      })
    });
  }

  login(user, onComplete?: () => void) {
    let url = `${this.newUrl}auth/local/signin`;
    console.log(url)

    this.store.dispatch(new ActivateLoadingAction());
    this.clearSessionState();

    let encUser = { message: this.encrypt(user) };
    console.log('PAYLOAD:',encUser)
    this.http.post(url, encUser).subscribe((data: any) => {
      let decUser = this.parseEncryptedResponse(data);
      let user = decUser.data.items[0];
      console.log('DECUSER',decUser)
      this.privateKey = user.encKey;
      this.token = user.token;
      this.syncUserSession(user);
      console.log('USER:',this.user)
      this.refreshCurrentUserProfile(() => {
        this.getSpecialities();
        this.store.dispatch(new DeactivateLoadingAction());
        if (onComplete) onComplete();
        if(this.user.account_status == "plan_unpaid")
          this.route.navigate(['panel/settings/tarjetas']);
        else
          this.route.navigate(['panel']);
      });

    }, err => {
      this.handleRequestError(err, {
        deactivateLoading: true,
        fallback: 'No pudimos iniciar sesión. Intenta de nuevo en unos minutos.'
      });
      if (onComplete) onComplete();
      // this.presentAlert(err.error.msg);
    })
  }

  submitNom035PreRegistration(payload) {
    let url = `${this.newUrl}nom35/pre-register`;
    let encData = { message: this.encrypt(payload, "public") };

    return this.http.post(url, encData, { observe: 'response' });
  }

  getNom035GuideI() {
    let url = `${this.newUrl}nom35/guide-i`;
    return this.http.get(url);
  }

  evaluateNom035GuideI(payload) {
    let url = `${this.newUrl}nom35/evaluate`;
    let encData = { message: this.encrypt(payload, "public") };

    return this.http.post(url, encData, { observe: 'response' });
  }

  register(user) {

    let url = `${this.newUrl}auth/local/signup/patient-mm`;
    this.clearSessionState();

    let encUser = { message: this.encrypt(user) };
    console.log('ENCRYPTED DATA:',encUser)

    this.http.post(url, encUser).subscribe((data: any) => {
      console.log(data);
      let decUser = this.parseEncryptedResponse(data);
      let user = decUser.data.items[0];

      this.privateKey = user.encKey;
      this.token = user.token;
      this.syncUserSession(user);
      this.refreshCurrentUserProfile(() => {
        this.getSpecialities();
        if(this.user.account_status == "plan_unpaid")
          this.route.navigate(['panel/settings/tarjetas']);
        else
          this.route.navigate(['panel']);
      });
      ////this.route.navigate(['panel']);

      Swal.fire({
        icon: 'success',
        title: 'Registro Correcto',
        text: "Se ha registrado con exito",
        showConfirmButton: true,
            confirmButtonText: "ok",
            confirmButtonColor:'#023171',
      });
    }, err => {
      this.handleRequestError(err, {
        fallback: 'No pudimos completar el registro. Revisa tus datos e intenta de nuevo.'
      });
    })
  }

  logout() {
    this.clearSessionState();
    this.route.navigate(['/login']);
  }

  private clearSessionState() {
    this.store.dispatch(new DeactivateUserAction());
    this.store.dispatch(new UnsetCategorieAction());
    this.store.dispatch(new UnsetCategorieDoctorsAction());
    this.user = null;
    this.token = "";
    this.privateKey = "";
    this.conektaApiKey = "";
    this.loadingSpecialities = false;
    localStorage.removeItem('mindhelp_user');
  }

  private syncUserSession(user: any) {
    this.user = {
      ...this.user,
      ...user,
      photo_media_id: user?.photo_media_id || this.user?.photo_media_id
    };
    this.store.dispatch(new SetUserAction({ ...this.user }));
    localStorage.setItem('mindhelp_user', JSON.stringify(this.user));
  }

  rePassRequest(data) {
    let url = `${this.newUrl}auth/reset-password/request`;
    let encUser = { message: this.encrypt(data) };

    return this.http.post(url, encUser);
  }

  rePassword(data) {
    let url = `${this.newUrl}auth/reset-password`;
    let encUser = { message: this.encrypt(data) };

    return this.http.post(url, encUser);
  }

  isAuth(): boolean {
    console.log(this.user)
    console.log('USUARIO',JSON.parse(localStorage.getItem('mindhelp_user')))
    
    if (localStorage.getItem('mindhelp_user') != null) {
      this.user = JSON.parse(localStorage.getItem('mindhelp_user'))
      this.privateKey = this.user.encKey;
      this.token = this.user.token;
      this.store.dispatch(new SetUserAction({ ...this.user }))
      this.refreshCurrentUserProfile();

      return true;
      } else {
      this.route.navigate(['landing']);
      return false;
    }
  }

  /**
   *
   *
   * @param {*} data la informacion que encriptaras
   * @param {string} [type="public"] si la llave que usaras sera publica o privada
   * @returns retorna la data encryptada
   * @memberof AuthService
   */
  encrypt(data: any, type: string = "public") {
    let key = (type == "public") ? this.DEFAULT_ENC_KEY : this.privateKey;
    this.getKey(key);

    console.log('PRIVATE KEY:', this.privateKey)

    //let _key = CryptoJS.enc.Utf8.parse(this.publicKey);
    let _key = CryptoJS.enc.Utf8.parse(this.publicKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.secureIV);

    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data), _key, {
      keySize: 128,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  /**
   *
   *
   * @param {*} data la informacion que desencriptaras
   * @param {string} [type="public"] si la llave que usaras sera publica o privada
   * @returns retorna la data desencryptada
   * @memberof AuthService
   */
  decrypt(data: any, type: string = "public") {
    if (!data) {
      return "";
    }
    
    let key = (type == "public") ? this.DEFAULT_ENC_KEY : this.privateKey;
    this.getKey(key);
    

    let _key = CryptoJS.enc.Utf8.parse(this.publicKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.secureIV);

    let decrypted = CryptoJS.AES.decrypt(
      data, _key, {
      keySize: 128,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8)
    return decrypted;
  }

  parseEncryptedResponse(response: any, keyType: string = "public"): any {
    if (!response) return {};
    if (!response.message) return response;

    const decrypted = this.decrypt(response.message, keyType);
    if (!decrypted) return {};

    return JSON.parse(decrypted);
  }

  private parseEncryptedError(response: any): any {
    if (!response?.message) return response || {};

    this.hydrateSessionFromStorage();
    const keyTypes = this.privateKey ? ['private', 'public'] : ['public', 'private'];

    for (const keyType of keyTypes) {
      try {
        const decrypted = this.decrypt(response.message, keyType);
        if (!decrypted) continue;

        try {
          const data = JSON.parse(decrypted);
          if (data && (typeof data !== 'object' || Object.keys(data).length > 0)) return data;
        } catch {
          return { message: decrypted };
        }
      } catch {
        continue;
      }
    }

    return {};
  }

  private getParsedErrorMessage(data: any): string {
    if (!data) return '';
    if (typeof data === 'string') return data;

    if (Array.isArray(data)) {
      for (const item of data) {
        const message = this.getParsedErrorMessage(item);
        if (message) return message;
      }
      return '';
    }

    return data?.error?.errors?.[0]?.message
      || data?.error?.errors?.[0]?.raw?.description
      || data?.errors?.[0]?.message
      || data?.errors?.[0]?.raw?.description
      || data?.error?.message
      || (typeof data?.error === 'string' ? data.error : '')
      || data?.data?.message
      || data?.data?.error
      || data?.message
      || data?.msg
      || data?.description
      || '';
  }

  getRequestErrorMessage(err: any, fallback = 'Ocurrió un error del servidor. Intenta de nuevo en unos minutos.'): string {
    if (!err) return fallback;

    if (err.status === 0) {
      return 'No pudimos conectar con el servidor. Revisa tu conexión o intenta más tarde.';
    }

    const statusMessages = {
      400: 'Revisa la información ingresada.',
      401: 'Tu sesión expiró. Inicia sesión de nuevo.',
      403: 'No tienes permisos para continuar.',
      404: 'No encontramos la información solicitada.'
    };

    if (statusMessages[err.status]) {
      fallback = statusMessages[err.status];
    } else if (err.status >= 500) {
      fallback = 'El servidor tuvo un problema. Intenta más tarde.';
    }

    const exitDescription = err.headers?.get?.('X-Exit-Description') || '';
    if (exitDescription && !this.isTechnicalErrorMessage(exitDescription)) {
      if (exitDescription.toLowerCase().includes('no user with the specified id')) {
        return 'No encontramos la información de este usuario en el servidor de pruebas.';
      }

      return exitDescription;
    }

    const encryptedMessage = err.error && err.error.message;
    if (encryptedMessage) {
      const data = this.parseEncryptedError(err.error);
      const parsedMessage = this.getParsedErrorMessage(data);

      if (parsedMessage && !this.isTechnicalErrorMessage(parsedMessage)) {
        return parsedMessage;
      }

      return fallback;
    }

    const rawMessage = this.getParsedErrorMessage(err.error);

    if (rawMessage && !this.isTechnicalErrorMessage(rawMessage)) {
      return rawMessage;
    }

    return fallback;
  }

  showRequestError(err: any, fallback = 'Ocurrió un error del servidor. Intenta de nuevo en unos minutos.'): void {
    console.error('Request error:', err);
    Swal.fire({
      icon: 'error',
      title: err && err.status === 0 ? 'Error de conexión' : 'Error del servidor',
      text: this.getRequestErrorMessage(err, fallback),
      showConfirmButton: true,
      confirmButtonText: 'ok',
      confirmButtonColor: '#023171',
    });
  }

  handleRequestError(err: any, options: {
    fallback?: string,
    showModal?: boolean,
    deactivateLoading?: boolean,
    warnOnly?: boolean
  } = {}): void {
    if (options.deactivateLoading) {
      this.store.dispatch(new DeactivateLoadingAction());
    }

    const message = this.getRequestErrorMessage(err, options.fallback);

    if (err?.status === 401) {
      this.clearSessionState();
      this.route.navigate(['/login']);
    }

    if (options.warnOnly || options.showModal === false) {
      console.warn(message, err);
      return;
    }

    this.showRequestError(err, options.fallback);
  }

  private isTechnicalErrorMessage(message: string): boolean {
    const text = String(message).toLowerCase();
    return this.looksEncrypted(message)
      || text.includes('httperrorresponse')
      || text.includes('cors')
      || text.includes('preflight')
      || text.includes('ciphertext')
      || text.includes('networkerror')
      || text.includes('not found')
      || text.includes('unknown error')
      || text.includes('failed to fetch')
      || text.includes('cannot read');
  }

  private looksEncrypted(message: string): boolean {
    const value = String(message || '').trim();
    if (value.length < 120) return false;

    const compactValue = value.replace(/\s+/g, '');
    const base64Like = /^[A-Za-z0-9+/=]+$/.test(compactValue);

    return base64Like && compactValue.length > 180;
  }

  getKey(key) {
    this.secureIV = key.substr(0, 16);
    this.publicKey = key;
  }

  private hydrateSessionFromStorage(): boolean {
    if (this.token && this.privateKey && this.user) return true;

    const rawUser = localStorage.getItem('mindhelp_user');
    if (!rawUser) return false;

    try {
      this.user = JSON.parse(rawUser);
      this.privateKey = this.user && this.user.encKey ? this.user.encKey : "";
      this.token = this.user && this.user.token ? this.user.token : "";
      return !!this.token;
    } catch (err) {
      console.error('No se pudo leer la sesión local:', err);
      this.clearSessionState();
      return false;
    }
  }

  getSpecialities() {
    if (!this.hydrateSessionFromStorage()) {
      console.warn('No se cargaron categorías porque no hay sesión activa.');
      return;
    }

    if (this.loadingSpecialities) return;
    this.loadingSpecialities = true;
    this.store.dispatch(new UnsetCategorieAction());
    this.store.dispatch(new UnsetCategorieDoctorsAction());

    let url = `${this.newUrl}system/categories`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    const params = new HttpParams().set('_', Date.now().toString());

    this.http.get(url, { headers, params }).subscribe({
      next:(d: any) => {
        try {
          let data = this.parseEncryptedResponse(d, "private");
          const categories = data && data.data && Array.isArray(data.data.items) ? data.data.items : [];
          this.store.dispatch(new SetCategorieAction([...categories]))
        } catch (err) {
          try {
            let data = this.parseEncryptedResponse(d, "public");
            const categories = data && data.data && Array.isArray(data.data.items) ? data.data.items : [];
            this.store.dispatch(new SetCategorieAction([...categories]))
          } catch (publicErr) {
            console.error('Error procesando categorías:', err, publicErr);
            this.store.dispatch(new SetCategorieAction([]))
          }
        } finally {
          this.loadingSpecialities = false;
        }
      },
      error: (err) => {
        this.loadingSpecialities = false;
        this.handleRequestError(err, {
          fallback: 'No pudimos cargar las categorías. Intenta de nuevo en unos minutos.'
        });
        this.store.dispatch(new SetCategorieAction([]))
      }
    })
  }

  getDoctors(id) {

    this.store.dispatch(new ActivateLoadingAction());

    const monthReference = moment().startOf('month').valueOf().toString();
    let url = `${this.newUrl}ecomm/users/${id}/time-slot-by-day`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token,
    });
    const params = new HttpParams()
      .set('time_as_reference', monthReference)
      .set('time_type', 'month')
      .set('_', Date.now().toString());

    this.http.get(url, { headers, params }).subscribe((data: any) => {
      try {
        let decUser = this.parseEncryptedResponse(data, "public");
        let doctors = decUser && decUser.data && Array.isArray(decUser.data.items) ? decUser.data.items : [];

        this.store.dispatch(new SetCategorieDoctorsAction([...doctors]))
      } catch (err) {
        console.error('Error procesando terapeutas:', err);
        this.store.dispatch(new SetCategorieDoctorsAction([]))
      } finally {
        this.store.dispatch(new DeactivateLoadingAction());
      }
    }, err => {
      this.store.dispatch(new SetCategorieDoctorsAction([]))
      this.handleRequestError(err, {
        deactivateLoading: true,
        fallback: 'No pudimos cargar los terapeutas. Intenta de nuevo en unos minutos.'
      });
    })
  }

  getDoctorsFilter(d) {
    const filterReference = moment(d.startDate, 'YYYY-MM-DD HH:mm:ss', true);
    const monthReference = (filterReference.isValid() ? filterReference : moment())
      .startOf('month')
      .valueOf()
      .toString();
    let url = `${this.newUrl}ecomm/users/${d.users}/time-slot-by-day`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token,
    });
    let params = new HttpParams()
      .set('time_as_reference', monthReference)
      .set('time_type', 'month')
      .set('_', Date.now().toString());

    if (d.startDate) params = params.set('startDate', d.startDate);
    if (d.endDate) params = params.set('endDate', d.endDate);
    if (d.searchTerm) params = params.set('searchTerm', d.searchTerm);
    if (d.gender) params = params.set('gender', d.gender);

    this.http.get(url, { headers, params }).subscribe((data: any) => {
      try {
        console.log(data)
        let decUser = this.parseEncryptedResponse(data, "public");
        let doctors = decUser && decUser.data && Array.isArray(decUser.data.items) ? decUser.data.items : [];
        // let doctors = data.data.items;

        this.store.dispatch(new SetCategorieDoctorsAction([...doctors]))
      } catch (err) {
        console.error('Error procesando terapeutas filtrados:', err);
        this.store.dispatch(new SetCategorieDoctorsAction([]))
      } finally {
        this.store.dispatch(new DeactivateLoadingAction());
      }
    }, err => {
      this.store.dispatch(new SetCategorieDoctorsAction([]))
      this.handleRequestError(err, {
        deactivateLoading: true,
        fallback: 'No pudimos aplicar los filtros. Intenta de nuevo en unos minutos.'
      });
    })
  }

  getDoctorDetail(id, cat_id) {
    const monthReference = moment().startOf('month').valueOf().toString();
    let url = `${this.newUrl}ecomm/users/${cat_id}/time-slot-by-day`;

    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token,
    });
    const params = new HttpParams()
      .set('time_as_reference', monthReference)
      .set('time_type', 'month')
      .set('userId', id)
      .set('_', Date.now().toString());

    return this.http.get(url, { headers, params });
  }

  getDoctorTimeList(id, time, timeType?: string) {
    let url = `${this.newUrl}users/${id}/time-slots`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token,
    });

    let params = new HttpParams().set('time_as_reference', time);
    if (timeType) {
      params = params.set('time_type', timeType);
    }

    return this.http.get(url, { headers, params });
  }

  getDoctorTimeListOtherApi(id, time, timeType?: string) {
    let url = `${environment.apimh_url}users/${id}/time-slots`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token,
    });

    let params = new HttpParams().set('time_as_reference', time);
    if (timeType) {
      params = params.set('time_type', timeType);
    }

    return this.http.get(url, { headers, params });
  }

  getHours(id, time, view) {
    let url = `${this.newUrl}ecomm/users/find-availability-by-doctor`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token,
    });

    const params = new HttpParams().set('time_as_reference', time)
      .set('time_type', 'month')
      .set('time_slot_type', 'hasAvailability')
      .set('userId', id);

    return this.http.get(url, { headers, params });
  }

  applyCupon(data) {
    let url = `${this.newUrl}system/promo-codes/verify`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    console.log('TOKEN', this.token)
    let encData = { message: this.encrypt(data, "private") };

    return this.http.post(url, encData, { headers });
  }

  saveBooking(data) {
    let url = `${this.newUrl}appointments`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    let encData = { message: this.encrypt(data, "private") };
    console.log('ENCDATA:',encData)
    console.log('DATA', data)

    return this.http.post(url, encData, { headers });
  }

  savePayedBooking(data) {
    data.id_user = this.user.id
    console.log('DATOS', data)
    let url = `${this.newUrl}payment/pay`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    let encData = { message: this.encrypt(data, "private") };
    return this.http.post(url, encData, { headers });
  }

  getProfile(id) {
    let url = `${this.newUrl}users/${id}`;
    console.log('URL:',url)
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    console.log('HEADERS:',headers)
    return this.http.get(url, { headers });
  }

  refreshCurrentUserProfile(onComplete?: () => void) {
    if (!this.user || !this.user.id || !this.token || !this.privateKey) {
      if (onComplete) onComplete();
      return;
    }

    this.getProfile(this.user.id).subscribe({
      next: (d: any) => {
        try {
          const decUser = this.parseEncryptedResponse(d, "private");
          const profile = decUser?.data?.items?.[0];
          if (profile) {
            this.syncUserSession(profile);
          }
        } catch (err) {
          console.error('No se pudo procesar el perfil completo:', err);
        } finally {
          if (onComplete) onComplete();
        }
      },
      error: (err) => {
        const unauthorized = err?.status === 401;
        this.handleRequestError(err, {
          showModal: false,
          fallback: 'No pudimos cargar el perfil completo del usuario.'
        });
        if (!unauthorized && onComplete) onComplete();
      }
    });
  }

  editProfile(data, id) {
    let url = `${this.newUrl}users/${id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.token
    });
    let encData = { message: this.encrypt(data, "private") };

    return this.http.patch(url, encData, { headers });
  }

  getChats(id) {
    let url = `${this.newUrl}users/${id}/chats`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers });
  }

  getChatHistory(userId, chatId) {
    let url = `${this.newUrl}users/${userId}/chats/${chatId}/messages`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    this.http.get(url, { headers }).subscribe((d: any) => {
      let decUser = this.parseEncryptedResponse(d, "private");

      this.store.dispatch(new GetChatHistory([...decUser.data.items]))
    }, err => {
      this.handleRequestError(err, {
        fallback: 'No pudimos cargar los mensajes. Intenta de nuevo en unos minutos.'
      });
    });
  }

  sendMessage(userId, chatId, data) {
    let url = `${this.newUrl}users/${userId}/chats/${chatId}/messages`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    let encData = { message: this.encrypt(data, "private") };

    return this.http.post(url, encData, { headers });
  }

  getTimeZones() {
    return this.http.get("https://worldtimeapi.org/api/timezone")
  }

  getInfoTimeZone(timezone){
    if(timezone){
      return this.http.get(`https://worldtimeapi.org/api/timezone/${timezone}`)
    }
  }

  //  funtion to get the dates
  datesToConfirm(id) {

    let url = `${this.newUrl}users/${id}/appointments/status/to-confirm`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers });
  }

  datesToBeCancelled(id) {
    let url = `${this.newUrl}users/${id}/appointments/status/to-cancel`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers });
  }

  datesCancelled(id) {
    let url = `${this.newUrl}users/${id}/appointments/status/cancelled`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers });
  }

  datesFinish(id) {
    let url = `${this.newUrl}users/${this.user.id}/appointments/${id}/status/finished`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    return this.http.post(url, {}, { headers });
  }

  inquiriesFinish(id,userId) {
    let url = `${this.newUrl}users/${userId}/inquiries/${id}/status/finished`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    return this.http.post(url, {}, { headers });
  }

  endDatesFinish(limit = 10,skip=0) {

    let url = `${this.newUrl}users/${this.user.id}/appointments/status/finished`
          +(limit > 0 ? `?limit=${limit}`:``)+(skip > 0 ? `&skip=${skip}`:``);
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers });

  }

  datesScheduled(id) {
    let url = `${this.newUrl}users/${id}/appointments/status/scheduled`;
    console.log('URL',url)
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers });
  }

  datesToBeConfirmed(id) {
    let url = `${this.newUrl}users/${id}/appointments/status/to-confirm`;
    console.log('URL',url)
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers });
  }

  datesInProgress(id) {
    let url = `${this.newUrl}users/${id}/appointments/status/in-progress`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers });
  }

  conectDate(userId, dateId) {
    let url = `${this.newUrl}users/${userId}/appointments/${dateId}/status/connected`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.post(url, {}, { headers });
  }

  conectInquiry(userId, dateId) {
    let url = `${this.newUrl}users/${userId}/inquiries/${dateId}/status/connected`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.post(url, {}, { headers });
  }

  // finish

  sendReview(id, data) {
    let url = `${this.newUrl}appointments/${id}/reviews`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    let encData = { message: this.encrypt(data, "private") };

    return this.http.post(url, encData, { headers });
  }

  getReviews(idDoctor) {
    let url = `${this.newUrl}users/${idDoctor}/reviews`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers });
  }

  getImgId(id) {
    let url = `${this.newUrl}system/media/${id}`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers })
  }

  contactUs(data) {
    let url = `${this.newUrl}system/emails/send-contact-form`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token,
    });

    let encData = { message: this.encrypt(data, "private") };

    this.http.post(url, encData, { headers }).subscribe((d: any) => {
      Swal.fire({
        icon: 'success',
        title: 'Mensaje enviado',
        text: "En un momento nos comunicaremos con usted",
        showConfirmButton: true,
            confirmButtonText: "ok",
            confirmButtonColor:'#023171',
      });
    }, err => {
      this.handleRequestError(err, {
        fallback: 'No pudimos enviar el mensaje. Intenta de nuevo en unos minutos.'
      });
    });
  }

  // reBooking
  moveBooking(id,data) {
    let url = `${this.newUrl}appointments/${id}/move`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    let encData = { message: this.encrypt(data, "private") };
    console.log('ENCRYPTED DATA:',encData)
    console.log('TOKEN:', this.token)
    return this.http.post(url, encData, { headers });
  }

  cancelBooking(body, bookin) {
    console.log('BOOKIN', bookin)
    let url = `${this.newUrl}users/${this.user.id}/appointments/${bookin.id}/status/cancelled`;
    console.log('URL',url)
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token,
    });
    //let encryptedBody = { text: this.encrypt(body, "private") };
    return this.http.post(url,body,{headers}) 
  }

  // Suscriptions and plans

  getPlans() {
    let url = `${this.newUrl}system/payments/plans`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    return this.http.get(url, { headers });
  }

  addSuscription(idSub, data) {
    let url = `${this.newUrl}users/${this.user.id}/payments/suscriptions/${idSub}`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    // let encData = { message: this.encrypt(data, "private") };

    return this.http.post(url, {}, { headers });
  }

  deleteSuscription(idSub?) {
    let url = `${this.newUrl}users/${this.user.id}/payments/suscriptions/`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    // let encData = { message: this.encrypt(data, "private") };

    return this.http.delete(url, { headers });
  }

  getCurrentSuscription() {
    let url = `${this.newUrl}users/${this.user.id}/payments/suscriptions/active`;
    console.log('URL:',url)
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    console.log('CABEZAS:',headers)

    return this.http.get(url, { headers });
  }

  getCurrentCompany(){
    if(this.user.company_id){
      let url = `${this.newUrl}admin/companies/${this.user.company_id}`;
      const headers = new HttpHeaders({
        'Authorization': 'Bearer ' + this.token
      });
      return this.http.get(url, { headers });
    }else{
      return null;
    }
  }

  getUsesUser(){
    let url = `${this.newUrl}users/${this.user.id}/uses`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    return this.http.get(url, { headers });
  }

  deleteRecipe(data){
    let url = `${this.newUrl}users/${data.folio}/recipes/`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    return this.http.delete(url, { headers });
  }

  getRecipes(){
    let url = `${this.newUrl}users/${this.user.id}/recipes/1`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    return this.http.get(url, { headers });
  }

  setRecipe(data){
    let url = `${this.newUrl}users/${this.user.id}/recipes`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    let encData = { message: this.encrypt(data,"private") };

    return this.http.post(url, encData , { headers });
  }

  /*getUsesUser(){
    let url = `${this.newUrl}users/${this.user.id}/uses`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    return this.http.get(url, { headers }).subscribe((res: any) =>{
      let encData = JSON.parse(this.decrypt(res.message, 'private'));
      if(encData.data.items.length > 0){
        this.user.max_uses = encData.data.items[0].max_uses;
        this.user.uses = encData.data.items[0].uses;
      }
    },()=>{});
  }*/

  getUnusedPromoCodes(id){
    let url = `${this.newUrl}system/find-user-promo-codes?patient_user_id=${id}`
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    return this.http.get(url, { headers });
  }
  
  getUserCards(){
    console.log(this.user.id)
    let url = `${this.newUrl}cards/get?id_user=${this.user.id}`
    console.log('URL', url)
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    return this.http.get(url, { headers });
  }

  addCard(data) {
    data.id_user = this.user.id
    console.log('CUERPO:', data)
    let url = `${this.newUrl}cards/create`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    let encData = { message: this.encrypt(data, "private") };

    return this.http.post(url, encData, { headers });
  }

  deleteCard(id) {
    const body = {card_token:id, id_user:this.user.id}
    console.log(body)
    let url = `${this.newUrl}cards/delete`;
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });

    let encData = { message: this.encrypt(body, "private") };

    return this.http.post(url, encData, { headers });
  }

  confirmAppointment(id){
    let url = `${this.newUrl}appointments-confirm?id=${id}`
    console.log('URL', url)
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token
    });
    return this.http.get(url, { headers });
  }
}
